import type { ProviderSkillInvocation, ServerProviderSkill } from "@afar-research/contracts";

/**
 * Bind an App-owned Skill Bundle to the chip an arranged prompt already leads
 * with, so the provider invokes the skill natively instead of the agent reading
 * a `$name` it may or may not honour. Null when this provider's catalog carries
 * no usable bundle by that name: the prompt keeps its token and the Workspace
 * Instruction Profile remains the only instruction.
 */
export function resolveAppOwnedSkillInvocation(
  skills: ReadonlyArray<ServerProviderSkill>,
  skillBundleId: string,
): ProviderSkillInvocation | null {
  const skill = skills.find(
    (candidate) =>
      candidate.name === skillBundleId &&
      candidate.ownership === "app" &&
      candidate.enabled &&
      candidate.usable !== false,
  );
  if (!skill) return null;
  return {
    name: skill.name,
    path: skill.path,
    // Arranged prompts lead with their chip, so the token starts the prompt.
    // `planProviderSkillDispatch` re-anchors it against the text actually sent.
    promptStart: 0,
    promptEnd: skillBundleId.length + 1,
  };
}
